import { render, staticRenderFns } from "./DeleteFileDialog.vue?vue&type=template&id=b9c0e86e&scoped=true&"
import script from "./DeleteFileDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteFileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c0e86e",
  null
  
)

export default component.exports